import React, { Dispatch, SetStateAction } from "react";
import AppButton from "../Button/AppButton";
import { AromMenuOptions } from "../../movenet/params";
import { useHistory } from "react-router-dom";
import { ASSESSMENT_STATUSES } from "../../movenet/params";

interface Props {
  setShowAromMenuModal: Dispatch<SetStateAction<boolean>>;
  showPhaseControls?: boolean;
}

const AromMenuModal: React.FC<Props> = ({ setShowAromMenuModal, showPhaseControls = true }) => {
  let history = useHistory();
  return (
    <div
      style={{
        gap: "24px",
        borderRadius: "14.3px",
        display: "flex",
        flexDirection: "column",
        padding: "32px 45px 32px 45px",
        justifyItems: "center",
        alignItems: "center",
      }}
    >
      <p
        style={{
          fontSize: "64px",
          fontWeight: "700",
          lineHeight: "87.16px",
          textAlign: "center",
        }}
      >
        Menu
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "32px",
        }}
      >
        {showPhaseControls && (
          <AppButton
            label="Restart Phase"
            variant="secondary"
            onClick={() => {
              setShowAromMenuModal(false);
              AromMenuOptions.restartPhase = true;
              ASSESSMENT_STATUSES.exit_assessment_modal = false;
            }}
          />
        )}
        {showPhaseControls && (
          <AppButton
            label="Skip Phase"
            variant="secondary"
            onClick={() => {
              setShowAromMenuModal(false);
              AromMenuOptions.skipPhase = true;
              ASSESSMENT_STATUSES.exit_assessment_modal = false;
            }}
          />
        )}
        <AppButton
          label="Exit Assessment"
          variant="secondary"
          onClick={() => {
            setShowAromMenuModal(false);
            ASSESSMENT_STATUSES.exit_assessment_modal = true;
            ASSESSMENT_STATUSES.incomplete_test = true;
            // Stop all currently playing audio immediately
            if ((window as any).__activeAudioPlayer?.stop) {
              (window as any).__activeAudioPlayer.stop();
            }
            document.getElementById("output")?.classList.remove("mctsib-cam");
            const counter = sessionStorage.getItem("retry-counter");
            if (counter)
              sessionStorage.setItem(
                "retry-counter",
                (Number(counter) + 1).toString()
              );
            history.push("/patient-page");
          }}
        />
        <AppButton
          label="Resume"
          variant="primary"
          onClick={() => {
            setShowAromMenuModal(false);
            ASSESSMENT_STATUSES.exit_assessment_modal = false;
            AromMenuOptions.resume = true;
          }}
        />
      </div>
    </div>
  );
};

export default AromMenuModal;
